import React from 'react';
import { Row, Col } from 'reactstrap';
import { LuTag, LuShoppingBag, LuPercent, LuTrendingUp } from 'react-icons/lu';
import KpiCard from '../../../shared/components/KpiCard/KpiCard';
import formatBRL from '../../../shared/utils/formatBRL';

const CouponStats = ({ stats, totalCoupons }) => {
  return (
    <Row className="mb-4">
      <Col md={3} className="mb-3 mb-md-0">
        <KpiCard
          icon={LuTag}
          color="purple"
          label="Ativos"
          value={`${stats?.activeCoupons ?? 0} de ${totalCoupons ?? 0} cupons`}
        />
      </Col>
      <Col md={3} className="mb-3 mb-md-0">
        <KpiCard
          icon={LuShoppingBag}
          color="blue"
          label="Usos no período"
          value={stats?.usesThisMonth ?? 0}
          growth={stats?.usesGrowth}
        />
      </Col>
      <Col md={3} className="mb-3 mb-md-0">
        <KpiCard
          icon={LuPercent}
          color="orange"
          label="Descontos concedidos"
          value={formatBRL(stats?.discountsGranted ?? 0)}
          growth={stats?.discountsGrowth}
          subtitle="vs período anterior (só cupom de produto)"
        />
      </Col>
      <Col md={3}>
        <KpiCard
          icon={LuTrendingUp}
          color="green"
          label="Receita com cupons"
          value={formatBRL(stats?.revenueGenerated ?? 0)}
          growth={stats?.revenueGrowth}
        />
      </Col>
    </Row>
  );
};

export default CouponStats;
